var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',{staticStyle:{"padding":"0 !important"}},[_c('Menu'),_c('eosJsDocs')],1)}
var staticRenderFns = []

export { render, staticRenderFns }